import { css } from "../helpers/webComponents";
import { GameEventService } from "../services/GameEventService";
import { Page } from "../enums/Page";

const styles: string = css`
    :host {
        display: flex;
        justify-content: center;   /* horizontaal centreren */
        align-items: center;       /* verticaal centreren */
        position: fixed;
        inset: 0;                  /* shorthand voor top/left/right/bottom: 0 */
        width: 100vw;
        height: 100vh;
        z-index: 1000;
        background-color: black;
    }

    video {
        max-width: 100%;
        height: 100%;
        object-fit: contain; /* behoudt aspect ratio */
    }

    .skip-button {
        position: absolute;
        bottom: 40px;
        right: 40px;
        padding: 10px 20px;
        background: #1900ff;
        color: white;
        border-radius: 8px;
        cursor: pointer;
        font-size: 1rem;
        z-index: 1001;
    }

    .skip-button:hover {
        background: #3355ff;
    }
`;

export class IntroductionComponent extends HTMLElement {
    private readonly _gameEventService = new GameEventService();

    public connectedCallback(): void {
        this.attachShadow({ mode: "open" });
        this.render();
    }

    private render(): void {
        if (!this.shadowRoot) {
            return;
        }

        this.shadowRoot.innerHTML = `
      <style>${styles}</style>
      <video id="introVideo" autoplay muted>
        <source src="./assets/video/introduction-video.mp4" type="video/mp4" />
      </video>
      <div class="skip-button" id="skipBtn">Skip</div>
    `;

        const video: HTMLVideoElement | null = this.shadowRoot.querySelector<HTMLVideoElement>("#introVideo");
        const skipBtn: HTMLDivElement | null = this.shadowRoot.querySelector<HTMLDivElement>("#skipBtn");

        if (!video) {
            return;
        }

        // video klaar → level selector
        video.addEventListener("ended", () => {
            this._gameEventService.switchPage(Page.Canvas);
        });

        // skip knop
        skipBtn?.addEventListener("click", () => {
            this._gameEventService.switchPage(Page.Canvas);
        });
    }
}

window.customElements.define("introduction-component", IntroductionComponent);
